import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import {
  MultiLiaoAnalysis,
  useMultiLiaoAnalysis,
} from '../../pages/MultiAnalysisPage/useMultiLiaoAnalysis';

const MultiAnalysisContext = createContext<MultiLiaoAnalysis | undefined>(
  undefined
);

/**
 * Holds the Multi Analysis batch state (selection, preview results,
 * validation, review/save flags) at the AppLayout level so it survives
 * navigation between pages — e.g. opening a sample in Capillary Pressure and
 * coming back no longer resets the selection. State is scoped to the active
 * project (the hook clears itself when `?project=` changes).
 */
export const MultiAnalysisProvider = ({
  children,
}: React.PropsWithChildren) => {
  const location = useLocation();
  const projectUid = new URLSearchParams(location.search).get('project');
  const value = useMultiLiaoAnalysis(projectUid);

  return (
    <MultiAnalysisContext.Provider value={value}>
      {children}
    </MultiAnalysisContext.Provider>
  );
};

export const useMultiAnalysis = (): MultiLiaoAnalysis => {
  const context = useContext(MultiAnalysisContext);
  if (!context) {
    throw new Error(
      'useMultiAnalysis must be used within a MultiAnalysisProvider'
    );
  }
  return context;
};
